module.exports = __webpack_public_path__ + "img/dynamic-5.060bf81a.png";